export default __webpack_public_path__ + "static/media/showandHide.6fc707e9.svg";